import request from '@/utils/http';
import { SRM } from '../../constant/constant.js';

// 货站信息分页列表
export const getStationInfos = data => {
    return request({
        url: `${SRM}/supplierStationInfos`,
        method: 'post',
        data
    });
};

// 货站联系人查询
export const getStationAllContacts = data => {
    return request({
        url: `${SRM}/supplierStationContacts/all`,
        method: 'post',
        data
    });
};

// 货站信息-批量启用
export const enableStation = data => {
    return request({
        url: `${SRM}/batchEnableStation`,
        method: 'post',
        data
    });
};

// 货站信息-批量停用
export const disableStation = data => {
    return request({
        url: `${SRM}/batchDisableStation`,
        method: 'post',
        data
    });
};

// 货站信息-批量删除
export const deleteStation = data => {
    return request({
        url: `${SRM}/supplierDeleteStation`,
        method: 'post',
        data
    });
};

// 货站联系人-批量启用
export const enableContact = data => {
    return request({
        url: `${SRM}/batchEnableStationContact`,
        method: 'post',
        data
    });
};

// 货站联系人-批量停用
export const disableContact = data => {
    return request({
        url: `${SRM}/batchDisableStationContact`,
        method: 'post',
        data
    });
};

// 货站联系人-批量删除
export const deleteContact = data => {
    return request({
        url: `${SRM}/supplierDeleteStationContact`,
        method: 'post',
        data
    });
};

// 货站信息-根据企业名查信用代码
export const getCreditCodeByName = params => {
    return request({
        url: `${SRM}/getCreditCodeByName`,
        method: 'get',
        params
    });
};

// 货站信息-新增
export const addStation = data => {
    return request({
        url: `${SRM}/supplierAddStation`,
        method: 'post',
        data
    });
};

// 货站信息-编辑
export const updateStation = data => {
    return request({
        url: `${SRM}/supplierUpdateStation/${data.id}`,
        method: 'post',
        data
    });
};

// 检验供应商货站联系人是否存在
export const checkExists = data => {
    return request({
        url: `${SRM}/checkSupplierStationContactExists`,
        method: 'post',
        data
    });
};

// 货站联系人-新增
export const addContact = data => {
    return request({
        url: `${SRM}/supplierAddStationContact`,
        method: 'post',
        data
    });
};

// 货站联系人-编辑
export const updateContact = data => {
    return request({
        url: `${SRM}/supplierUpdateStationContact/${data.id}`,
        method: 'post',
        data
    });
};